.url-blocklist-content {
    max-width: 400px;
}

.url-list {
    margin-top: 12px;
}

.url-row {
    position: relative;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 8px;
    padding: 8px 12px;
    border-radius: 3px;
    transition: background-color 200ms ease;
}

.url-row:hover {
    background-color: var(--off-white);
}

.url-row-text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
}

.url-row-toolbar {
    position: absolute;
    top: -8px;
    right: 8px;
    z-index: 1;
    animation: url-row-toolbar-slide-in 150ms ease-out;
}

@keyframes url-row-toolbar-slide-in {
    from {
        opacity: 0;
        transform: translateY(8px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (prefers-reduced-motion: reduce) {
    .url-row-toolbar {
        animation: none;
    }
}
